import axios from "axios";

export default {
  loadInteriors ({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/interiors`).then(res => {
        resolve(res.data);
        commit('updateInteriors', res.data);
        commit('updateInteriorActive', res.data[0].colors[0]);
      }, error => {
        reject(error)
      })
    })
  },

  loadWindows ({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/windows/colors-list`).then(res => {
        resolve(res.data);
        commit('updateWindows', res.data);
        commit('updateWindowActive', res.data[0]);
      }, error => {
        reject(error)
      })
    })
  },
}
